import * as types from './mutation-types'

export const fetchCommunications = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/super/admin/communications`, { params }).then((response) => {
            commit(types.BOOTSTRAP_COMMUNICATIONS, response.data.communications.data)
            commit(types.SET_TOTAL_COMMUNICATIONS, response.data.communications.total)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const createCommunication = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/super/admin/communications/create`, { params }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addCommunication = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/super/admin/communications', data).then((response) => {
            commit(types.ADD_COMMUNICATION, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchCommunication = ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/super/admin/communications/${id}/edit`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateCommunication = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/super/admin/communications/${data.id}`, data).then((response) => {
            commit(types.UPDATE_COMMUNICATION, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const changeStatusCommunication = ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/super/admin/communications/${id}/statusChange`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const selectAllCommunications = ({ commit, dispatch, state }) => {
    if (state.selectedCommunications.length === state.communications.length) {
        commit(types.SET_SELECTED_COMMUNICATIONS, [])
        commit(types.SET_SELECT_ALL_STATE, false)
    } else {
        let allCommunicationIds = state.communications.map(cust => cust.id)
        commit(types.SET_SELECTED_COMMUNICATIONS, allCommunicationIds)
        commit(types.SET_SELECT_ALL_STATE, true)
    }
}
export const selectCommunication = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_COMMUNICATIONS, data)
    if (state.selectedCommunications.length === state.communications.length) {
        commit(types.SET_SELECT_ALL_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE, false)
    }
}
export const setSelectAllState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE, data)
}